import { Component, Input, OnInit, inject, output } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EnumService } from '../../../services/enum.service';
import { EnumValues, ModalService, Note, NotesSidebarComponent, UserLite } from '@card-software/library';
import { PurchaseOrderRoles } from '../../../models/roles/roles-group';
import { UserAuthenticationService } from '../../../services/user-authentication.service';
import { setOptionsForPrimeNg } from '../../../PrimeNG/utils';
import { ExternalRequisition } from '../../../models/requisitions/interfaces/external-requisition';
import { TableQuotationsComparativeService } from '../../../services/table-quotations-comparative.service';
import { Quotation } from '../../../models/order/quotation';
import { AuthService } from '@card-software/nexus-utilities';

export interface Entry {
  lineId: string;
  itemCode: string;
  itemDisplayName: null;
  comment: null;
  uom: number;
  quantity: number;
  approved: boolean;
  changeHistory: unknown[];
}

@Component({
  selector: 'app-quotations-viewer',
  templateUrl: './quotations-viewer.component.html',
  styleUrl: './quotations-viewer.component.scss',
})
export class QuotationsViewerComponent implements OnInit {
  @Input() requisition: ExternalRequisition | null = null;
  @Input() quotations: Quotation[] = [];

  emitRefreshPage = output<boolean>();

  isLoading = 0;
  requisitionFormGroup = new FormGroup({
    id: new FormControl<string | null>(null),
    requisitionType: new FormControl<string | null>(null),
    createdDate: new FormControl<string | Date | null>(null),
    priority: new FormControl<string | null>(null),
  });
  requisitionTypes: EnumValues = {};
  requisitionPriority: EnumValues = {};
  requisitionStatuses: EnumValues = {};
  // properties for notes component
  userLite: UserLite | null = null;
  notes: Note[] = [];
  setOptionsForPrimeNg = setOptionsForPrimeNg;
  public status = new FormControl<number>(0, {
    nonNullable: true,
    validators: Validators.required,
  });
  newQuote = false;
  editingQuotation: Quotation | null = null;
  showDialogNewQuote = false;

  private enumService = inject(EnumService);
  private modalService = inject(ModalService);
  private userAuthenticationService = inject(UserAuthenticationService);
  private router = inject(Router);
  private tableQuotationsComparativeService = inject(TableQuotationsComparativeService);

  constructor() {
    this.requisitionTypes = this.enumService.getEnum('ExternalRequisitionType', 'orderEnums').values;
    this.requisitionPriority = this.enumService.getEnum('ExternalRequisitionPriority', 'orderEnums').values;
    this.requisitionStatuses = this.enumService.getEnum('ExternalRequisitionStatusType', 'orderEnums').values;
    this.userLite = this.userAuthenticationService.userLite;
  }

  ngOnInit(): void {
    // NOTE: This should be the only place where we set data for the table service, pushing data is okay.
    this.tableQuotationsComparativeService.ClearAll();
    this.tableQuotationsComparativeService.SetProductsRequired(this.requisition?.entries ?? []);
    this.quotations.forEach((quotation) => {
      this.tableQuotationsComparativeService.PushQuotationsItems([quotation]);
    });
    console.log(this.requisition);
  }

  canEdit() {
    // if Admin or Editor
    if (AuthService.hasRole(PurchaseOrderRoles.PurchaseOrderAdmin) || AuthService.hasRole(PurchaseOrderRoles.PurchaseOrderEditor)) {
      return true;
    }
    // if Viewer
    if (AuthService.hasRole(PurchaseOrderRoles.PurchaseOrderViewer)) {
      return false;
    }
    // Default
    return false;
  }

  onViewMore(): void {
    this.openNotesModal();
  }

  openNotesModal(): void {
    const modalData = {
      notes: this.notes,
      userLite: this.userLite,
      viewOnly: true,
    };

    this.modalService.open(NotesSidebarComponent, {}, modalData).subscribe({
      next: (result) => {
        if (result && result.action === 'noteAdded') {
          this.notes = result.data.notes;
        }
      },
      error: (error) => {
        console.error('Error handling notes modal result:', error);
      },
    });
    setTimeout(() => {
      const modalElement = document.querySelector('.panel.modal') as HTMLElement;
      if (modalElement) modalElement.style.maxWidth = '50%';
      modalElement.style.width = '50%';
    }, 100);
  }

  redirectToRequisitionQuoteDetails() {
    this.router.navigate(['/requisition-quote-details'], {
      queryParams: { id: this.requisition?.id ?? 'new' },
    });
  }
  onEditQuotation(quotationId: string): void {
    // Find the quotation by ID from the table service
    const quotation = this.tableQuotationsComparativeService.getQuotationById(quotationId);
    if (quotation) {
      this.editingQuotation = quotation;
      this.newQuote = true; // Open the modal
    }
  }

  emitterEvent(event: boolean): void {
    this.editingQuotation = null;
    this.newQuote = event;
    this.emitRefreshPage.emit(true);
  }
}
